import { store } from '@App/Store/Store'
import { Socket, Channel, LongPoll } from 'phoenix'
import SocketChannel from './Lib/SocketChannel'
import { meta } from '@App/Meta'
import { emuladorAndroid } from '@Shared/Device'

class Conn {
    constructor() {
        this.firstOpen = true
        this.userChannel = null
        this.otherChannels = []

        this.userChannel = new SocketChannel('core_users:' + meta('user-id'))
        // this.userChannel = new SocketChannel('core_users:10')
    }

    conectar() {
        if (typeof jest !== 'undefined') return

        let endpointFastlane = emuladorAndroid() ? 'ws://10.0.2.2:4000' : meta('fastlane-url')
        let urlPrefix = meta('fastlane-prefix') || ''

        this.socket = new Socket(endpointFastlane + urlPrefix + '/socket', {
            transport: location.href.indexOf('longpoll') !== -1 ? LongPoll : undefined,
            params: {
                token: meta('user-token'),
                canal: 'core_users:' + meta('user-id'),
                user_agent: navigator.userAgent,
                language: navigator.language,
            },
        })

        this.userChannel.connect(this.socket)

        // O evento "onOpen" é chamado em duas ocasiões: na primeira conexão e em reconexões.
        // Se for a primeira conexão, a lista de "idsRecebidos" vai estar vazia, afinal acabamos de nos conectar.
        // Se a lista não estiver vazia, quer dizer que é uma reconexão e nós devemos perguntar para o servidor.
        this.socket.onOpen(async () => {
            store.commit('atualizarStatusWebsocket', 'conectado')

            if (!this.firstOpen) {
                setTimeout(() => {
                    this.userChannel.replayEvents()
                    this.otherChannels.map(c => c.replayEvents())
                }, 500)
            }

            this.firstOpen = false
        })

        this.socket.onClose(closeEvent => {
            store.commit('atualizarStatusWebsocket', 'desconectado')
        })

        this.socket.onError(errorEvent => {
            console.log('Socket error', errorEvent)
            this.socket.transport = LongPoll
        })

        this.socket.connect()

        this.presenceChannel = this.socket.channel('presence:core_users:' + meta('user-id'))
        this.presenceChannel.join().receive('error', res => {
            console.log('não foi possível se juntar ao canal de presence')
        })
    }

    /**
     * Acesso low-level ao channel do Phoenix. Use com cuidado.
     *
     * @param {string} nomeDoCanal "core_users:10"
     */
    channel(nomeDoCanal) {
        if (!this.socket) return null
        return this.socket.channel(nomeDoCanal)
    }
}

export const defaultConn = new Conn()

export function joinDelegateCallbacks(channelName) {
    let channel = new SocketChannel(channelName)
    channel.delegateCallbacks(defaultConn.userChannel)
    channel.connect(defaultConn.socket)

    defaultConn.otherChannels.push(channel)
}

/**
 * Acesso low-level ao channel do Phoenix. Use com cuidado.
 *
 * @param {string} nomeDoCanal "core_users:10"
 * @return {Channel}
 */
export function channel(nomeDoCanal) {
    return defaultConn.channel(nomeDoCanal)
}

/**
 * Registra um callback para o evento que será recebido no canal do usuário.
 *
 * @param {string} evento
 * @param {Function} callback
 */
export function onBroadcast(evento, callback) {
    defaultConn.userChannel.on(evento, callback)
}

/**
 * Remove o callback associado ao evento.
 *
 * @param {string} evento
 * @param {Function} callback
 */
export function offBroadcast(evento, callback) {
    defaultConn.userChannel.off(evento, callback)
}

/**
 * Evento emitido direto no canal do usuário, sem a abstração do "broadcast". Usado para eventos que não importam
 * serem perdidos caso tenha uma queda na conexão (como Digitando... e Gravando áudio...)
 *
 * @param {string} evento
 * @param {Function} callback
 */
export async function onCustom(evento, callback) {
    if (!defaultConn.userChannel.channel) {
        await new Promise(resolve => setTimeout(resolve, 100))
    }

    defaultConn.userChannel.channel.on(evento, callback)
}

/**
 * Envia um evento pelo canal do usuário e resolve a promessa com a resposta do servidor.
 *
 * @param {string} evento
 * @param {*} dados
 */
export function fastlane(evento, dados, opts = {}) {
    return defaultConn.userChannel.fastlane(evento, dados, opts)
}
